import { createVNode, mergeProps } from "vue";
export default {
  name: 'MoveIcon',
  props: {
    size: {
      type: String,
      default: '16',
      validator: s => !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x'
    }
  },

  setup(props, ctx) {
    const size = props.size.slice(-1) === 'x' ? props.size.slice(0, props.size.length - 1) + 'em' : parseInt(props.size) + 'px';
    const attrs = { ...ctx.attrs
    };
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    return () => createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "class": "feather feather-move"
    }, { ...attrs
    }), [createVNode("polyline", {
      "points": "5 9 2 12 5 15"
    }), createVNode("polyline", {
      "points": "9 5 12 2 15 5"
    }), createVNode("polyline", {
      "points": "15 19 12 22 9 19"
    }), createVNode("polyline", {
      "points": "19 9 22 12 19 15"
    }), createVNode("line", {
      "x1": "2",
      "y1": "12",
      "x2": "22",
      "y2": "12"
    }), createVNode("line", {
      "x1": "12",
      "y1": "2",
      "x2": "12",
      "y2": "22"
    })]);
  }

};